if (window.jQuery) {
  jQuery(function ($) {
    // mailto function
    $('a[href^="mailto:"]').on('click', function () {
      if (window.ga) {
        var emaillink = jQuery(this).attr("href");
        ga("send", "event", "Email Enquiry", "Mailto Click", emaillink);
      }

      return true;
    });

    // tel: function
    $('a[href^="tel:"]').on('click', function () {
      if (window.ga) {
        var telephonenumber = jQuery(this).attr("href");
        ga("send", "event", "Telephone Enquiry", "Tel Link Click", telephonenumber);
      }

      return true;
    });

    // pdf function
    $('a[href$=".pdf"]').on('click', function () {
      if (window.ga) {
        var pdfurl = jQuery(this).attr("href");
        ga("send", "event", "PDF Download", "Download", pdfurl);
      }

      return true;
    });

    //external link click
    $("a:not([href^='/'],[href^='https://" + document.domain + "'],[href^='http://" + document.domain + "'],[href^='mailto'],[href^='tel'],[href^='#']").on('click', function () {
      if (window.ga && jQuery(this).attr("href") != "#") {
        ga(
          "send",
          "event",
          "External Link",
          "Link Click",
          jQuery(this).attr("href")
        );
      }
    });
  });
}
